var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-chip',{attrs:{"text":_vm.statusText(_vm.status),"color":_vm.statusColor(_vm.status),"small":_vm.small}})
}
var staticRenderFns = []

export { render, staticRenderFns }